<template>
  <div class="app-media-object">
    <div class="media align-items-center">
      <div class="app-media-object__icon">
        <slot name="icon" />
      </div>
      <div class="media-body">
        <div v-if="$slots.info" class="app-media-object__info">
          <slot name="info" />
        </div>
        <h5 class="app-media-object__content">
          <slot />
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppMediaObject'
};
</script>

<style lang="scss">
.app-media-object {
  border-radius: 4px;
  background: #FFFFFF;
  border: 1px solid #FFFFFF;
  box-shadow: 0 0 12px 0 rgba(0,0,0,0.12);
  padding: 20px;
  &__icon {
    color: $--color-red;
    align-self: center;
    margin-right: $--spacing-6;
    font-size: 24px;
    padding: 8px 14px;
    border-radius: 50%;
    background-color: #F3F3F3;
  }

  &__content {
    color: $--color-red;
    margin-bottom: 0;
  }
  &__info {
    color: $--color-dark-blue;
    font-weight: bold;
    font-size: 1em;
  }
}
</style>
